function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Clip 2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.00031 2.0117H20.053V21.8652H3.00031V2.0117Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 1",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.57341 3.5117C5.91641 3.5117 4.54041 4.8537 4.50141 6.5087V17.2037C4.46441 18.9167 5.81441 20.3277 7.51041 20.3657H15.5744C17.2434 20.2967 18.5654 18.9097 18.5534 17.2097V8.3397L13.9184 3.5117H7.58541H7.57341ZM7.58541 21.8657H7.47641C4.95441 21.8087 2.94641 19.7107 3.00141 17.1877V6.4907C3.05941 4.0097 5.10841 2.0117 7.57141 2.0117H7.58841H14.2384C14.4424 2.0117 14.6374 2.0947 14.7794 2.2417L19.8444 7.5187C19.9784 7.6577 20.0534 7.8447 20.0534 8.0377V17.2037C20.0714 19.7127 18.1174 21.7627 15.6044 21.8647L7.58541 21.8657Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 4",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.97 16.6865H2.75C2.336 16.6865 2 16.3505 2 15.9365C2 15.5225 2.336 15.1865 2.75 15.1865H9.97C10.384 15.1865 10.72 15.5225 10.72 15.9365C10.72 16.3505 10.384 16.6865 9.97 16.6865Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.97 12.5H2.75C2.336 12.5 2 12.164 2 11.75C2 11.336 2.336 11 2.75 11H9.97C10.384 11 10.72 11.336 10.72 11.75C10.72 12.164 10.384 12.5 9.97 12.5Z",
  fill: "black"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Fill 4_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.2985 8.98431H16.5435C14.7135 8.97931 13.2255 7.48731 13.2255 5.65931V2.75031C13.2255 2.33631 13.5615 2.00031 13.9755 2.00031C14.3895 2.00031 14.7255 2.33631 14.7255 2.75031V5.65931C14.7255 6.66331 15.5425 7.48131 16.5455 7.48431H19.2985C19.7125 7.48431 20.0485 7.82031 20.0485 8.23431C20.0485 8.64831 19.7125 8.98431 19.2985 8.98431Z",
  fill: "black"
});

var SvgContacts = function SvgContacts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/contacts"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 18,
    height: 20
  }, _ref2), _ref3), _ref4)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContacts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contacts.ce1c0aeb.svg";
export { ForwardRef as ReactComponent };